// types
import { IOption } from 'components/FormElements/Select'
import { ChartConfig } from 'types/charts'
import { IFilter, IChart, IRiskTemplate } from 'types/graphql'
// utils
import { getValueFromOption } from 'utils/form'
import { cleanChartQuery, getSavedChartConfig, normalizeChartConfig } from 'utils/charts/config'

export interface ChartFormValues {
  chartTitle?: string
  chartConfig?: ChartConfig
  riskTemplateId?: IOption
  filterId?: IOption
}

interface ChartFormSource {
  chart?: IChart
  riskTemplates: IRiskTemplate[]
  filters: IFilter[]
}

export const getChartFormValues = ({ chart, riskTemplates, filters }: ChartFormSource): ChartFormValues => {
  const config = chart ? getSavedChartConfig(chart) : normalizeChartConfig(null)

  const riskTemplate = riskTemplates.find((item) => item.id === config.query.riskTemplateId)
  const filter = config.query.filterId && filters.find((item) => item.id === config.query.filterId)

  return {
    chartTitle: chart?.title || '',
    chartConfig: config,
    riskTemplateId: riskTemplate ? { label: riskTemplate.name, value: riskTemplate.id } : undefined,
    filterId: filter ? { label: filter.name, value: filter.id } : undefined
  }
}

// The form keeps the template and the saved filter as select options at the top level, like the Card widget
export const getChartConfigFromForm = (values: ChartFormValues): ChartConfig => {
  const config = normalizeChartConfig(values.chartConfig)

  return cleanChartQuery({
    ...config,
    query: {
      ...config.query,
      riskTemplateId: getValueFromOption(values.riskTemplateId) || null,
      filterId: getValueFromOption(values.filterId) || null
    }
  })
}
